export class CheckAzureDiskEncryptionSetAccessRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskEncryptionSetId",
            "baseName": "diskEncryptionSetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CheckAzureDiskEncryptionSetAccessRequest.attributeTypeMap;
    }
    constructor() {
    }
}
